import { Chart } from 'chart.js';
import 'chartjs-adapter-date-fns';
import { configure } from 'mobx';
import { AutoInjectContext, registerTimezonePreferenceStore } from 'Mri.Web.Common';
import * as React from 'react';
import { createRoot } from 'react-dom/client';
import * as Sentry from '@sentry/react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { polyfill } from 'smoothscroll-polyfill';
import '../Styles/app.scss';
import { AccountView } from './Account/AccountView';
import { App } from './Core/App';
import { stores } from './stores/stores';

configure({ enforceActions: 'observed' });
polyfill();

const { accountStore } = stores;

Sentry.setContext('User', accountStore.user as any);

registerTimezonePreferenceStore(accountStore);

const container = document.getElementById('app') as HTMLElement;
const root = createRoot(container);

root.render(
    <AutoInjectContext.Provider value={stores}>
        <BrowserRouter>
            <Switch>
                <Route path="/account" component={AccountView} />
                <Route path="/" component={App} />
            </Switch>
        </BrowserRouter>
    </AutoInjectContext.Provider>
);
